import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
		wxJs:null,
        userInfo:{
            userId:null,//用户ID
            userTel:null,//用户电话
            userPrice:null,//用户余额
            shopId:null,//商家ID
            saleId:null,//业务员ID
            openId:null,//微信openID
            openImg:null,//头像地址
        }
    },
    mutations: {
        setUserInfo(state,params){
            state.userInfo.userId = params.user_id;
            state.userInfo.userTel = params.tel;
            state.userInfo.openId = params.openid;
            state.userInfo.shopId = params.shop_id;
            state.userInfo.userPrice = params.red_balance;
            state.userInfo.saleId = params.saleman_id;
            state.userInfo.openImg = params.open_img;
        },
        setUser(state,params){
            state.userInfo.userId = params.user_id;
            state.userInfo.userTel = params.tel;
            state.userInfo.openId = params.openid;
            state.userInfo.userPrice = params.red_balance;
            state.userInfo.openImg = params.open_img;

        },
        setOpenID(state,param){
            state.userInfo.openId = param;
        },
        setUserTel(state,param){
            state.userInfo.userTel = param;
        },
        setShopId(state,param){
            state.userInfo.shopId = param;
        },
        setSaleId(state,param){
            state.userInfo.saleId = param;
        },
        setPrice(state,param){
            state.userInfo.userPrice = param;
        },
		setWxJs(state,param){
			state.wxJs = param;
		},

    },
    actions: {
        setUserInfo({commit},params){
            commit('setUserInfo',params);
        },
        setUser({commit},params){
            commit('setUser',params);
        },
        setShopId({commit},param){
            commit('setShopId',param)
        },
        setSaleId({commit},param){
            commit('setSaleId',param)
        },
        setPrice({commit},param){
            commit('setPrice',param)
        },
        setUserTel({commit},param){
            commit('setUserTel',param)
        },
        setOpenID({commit},param){
            commit('setOpenID',param)
        },
		setWxJs({commit},param){
			commit('wxJs',param)
		},
    }
})
